var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-geo-box',{attrs:{"geo-option":"zip","need-next":true},on:{"go":_vm.goNext}},[_c('m-geo-zip',{attrs:{"geoType":5,"is-go":_vm.isGo},on:{"update:isGo":function($event){_vm.isGo=$event},"update:is-go":function($event){_vm.isGo=$event},"updateIsGo":function($event){}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd1ee25c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/GeoZip.vue
// module id = null
// module chunks = 